import React, { Component } from "react";
import OrderPage from "../../Components/Seller/Order";

export class Order extends Component {
  componentDidMount() {
    const {
      getpendingorderRequest,
      getprocessingorderRequest,
      getshippedorderRequest,
      getdeliveredorderRequest,
      getallorderRequest,
    } = this.props;
    getpendingorderRequest();
    getprocessingorderRequest();
    getshippedorderRequest();
    getdeliveredorderRequest();
    getallorderRequest();
  }
  render() {
    const {
      pendingorder,
      processingorder,
      shippedorder,
      deliveredorder,
      allorderdata,
      totalorder,
      updateorderstatusRequest,
    } = this.props;
    return (
      <>
        <OrderPage
          pendingorder={pendingorder}
          processingorder={processingorder}
          shippedorder={shippedorder}
          deliveredorder={deliveredorder}
          totalorder={totalorder}
          allorderdata={allorderdata}
          updateorderstatusRequest={updateorderstatusRequest}
        />
      </>
    );
  }
}

export default Order;
